import { Page, Pagebar, PagebarTitle } from '@monorepo/base/src/components/page/page';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import styles from './edit-creative.module.scss';
import { Fragment, useEffect, useState } from 'react';
import { PrimaryButton } from '@monorepo/base/src/components/buttons/buttons';
import { observer } from 'mobx-react';
import { useLocation, useParams } from 'react-router-dom';
import { Disable } from '@monorepo/base/src/components/disable/disable';
import { BottomBar, BottomBarActions } from '@monorepo/base/src/components/bottom-bar/bottom-bar';
import { useCreativeGet } from '../../../modules/hooks/apis/use-creative-get';
import { DispatchLogsTypes, useLogs } from '@monorepo/controlled/src/hooks/use-logs';
import { ErrorMsg } from '../../../modules/components/error-msg/error-msg';
import { BarLoader } from '@monorepo/base/src/components/bar-loader/bar-loader';
import { IAdminxStore } from '../../../modules/stores';
import { CreativeForm } from '../../../modules/components/forms/creative/creative.form';
import { DataAttribute } from '@monorepo/tools/src/lib/models/data-attr.model';
import { useNavigateParams } from '@monorepo/tools/src/lib/hooks/tools/use-navigate-params';

export const EditCreative = observer(() => {
	const { creativeStore } = useStores<IAdminxStore>();
	const [isFormClicked, setFormClicked] = useState<boolean>(false);

	const { dispatchLog } = useLogs();
	const navigate = useNavigateParams();
	const location = useLocation();
	const params = useParams();

	const creativeCrudStore = creativeStore.getCrud();

	useEffect(() => {
		creativeCrudStore.setIsLoading(true);
		creativeStore.resetCrud();
	}, [location]);

	if (params.creativeId) {
		useCreativeGet({ id: params.creativeId });
	}

	const brand = creativeCrudStore.getData().getBrand();
	const formStore = creativeCrudStore.getFormStore();
	const isValidForm = formStore.getIsValid();
	const isLoading = creativeCrudStore.getIsLoading();
	const isSuccess = creativeCrudStore.getIsSuccess();
	const error = creativeCrudStore.getHttpError();

	useEffect(() => {
		if (!isValidForm && isFormClicked) {
			dispatchLog({
				msg: 'Please complete all mandatory fields',
				type: DispatchLogsTypes.Error,
			});
		}
	}, [isFormClicked]);

	useEffect(() => {
		if (isSuccess) {
			navigate(-1);
			dispatchLog({
				msg: `Creative ${brand} was successfully edited`,
				type: DispatchLogsTypes.Success,
			});
			creativeCrudStore.setIsSuccess(false);
		}
	}, [isSuccess]);

	const onEditCreative = () => {
		setFormClicked(true);
		creativeStore.getCrud().edit();
	};

	return (
		<Fragment>
			<BarLoader is={isLoading} />
			<Disable is={isLoading}>
				<Page className={isLoading ? styles.loadingPage : ''}>
					<Pagebar>
						<PagebarTitle>
							<div className={styles.title}>Edit Creative</div>
						</PagebarTitle>
					</Pagebar>
					<CreativeForm />
				</Page>
				<BottomBar>
					{error ? <ErrorMsg error={error} /> : null}
					<BottomBarActions>
						<PrimaryButton
							onClick={() => onEditCreative()}
							debugProps={{ dataAttrs: [new DataAttribute('id', 'save_creative_button')] }}
							isRotateIcon={isLoading}
							icon={isLoading ? 'loading-01' : 'send-03'}>
							Save
						</PrimaryButton>
					</BottomBarActions>
				</BottomBar>
			</Disable>
		</Fragment>
	);
});
